import { Geotab } from "@fairfleet/geotab";
import { TripRef } from "../../trip/TripRef";
import fetchTripsWithAnnotations from "./fetchTripsWithAnnotations";
import getSetAnnotationChanges from "./getSetAnnotationChanges";

/**
 * Sets the {@link TripAnnotation} for the given trips.
 *
 * @remarks
 *
 * Attempts to ensure only one annotation exists per trip.
 *
 * @param geotab - The {@link Geotab} client.
 * @param text - The annotation text.
 * @param trips - The trips to update annotations for.
 */
export default async function setAnnotationForTrips(geotab: Geotab, text: string, trips: TripRef[]) {
  text = text.trim();

  const tripsWithAnnotations = await fetchTripsWithAnnotations(geotab, trips);
  const changes = [];

  for (const change of getSetAnnotationChanges(text, tripsWithAnnotations)) {
    if (change.kind === "set") {
      changes.push(geotab.set("TripAnnotation", change.annotation as any));
    } else if (change.kind === "add") {
      changes.push(geotab.add("TripAnnotation", change.annotation as any));
    } else if (change.kind === "remove") {
      changes.push(geotab.remove("TripAnnotation", change.annotation as any));
    }
  }

  await Promise.all(changes);
}
